module.exports = __webpack_public_path__ + "img/home-prize-2.62dd5a58.png";